<template>
  <ModalCard title="Parking Cash out">
    <div class="flex flex-col gap-8">
      <div>
        <h3 class="mb-3">
          Do you offer parking cash out to employees?
          <Tooltip>
            <template #title>
              <div>In a parking cash-out program, employees may choose to drive to work and use the employer-paid/subsidized parking space or receive the cash equivalent of the parking space from the employer.</div>
            </template>

            <PhInfo weight="fill" class="text-primary cursor-pointer" size="16" />
          </Tooltip>
        </h3>

        <RadioGroup :value="1">
          <Radio :style="radioStyle" :value="1">
            <div class="w-full flex items-center gap-4">
              <h4 class="text-base font-normal">Yes, how much per day?</h4>
              <CustumNumberInput
                class="flex-1"
                name="savinngs"
                :defaultData="0"
                prefix="$"
                placeholder=" "
                :rules="{min:0}"
                @setInput="setInput"
              />
            </div>
          </Radio>
          <Radio :style="radioStyle" :value="2" class="w-full">
            <h4 class="text-base font-normal">No</h4>
          </Radio>
        </RadioGroup>
      </div>

      <div>
        <h3 class="mb-1">Program start date:</h3>
        <CustumCalender
          name="expiration"
          :defaultData="defaultDate"
          :minDate="defaultDate"
          defaultFormate="MMM, DD YYYY"
          placeholder="Program start date"
          :rules="{
            required: false,
            }"
          @setInput="setInput"
        />
      </div>
    </div>
  </ModalCard>
</template>

<script>
import { PhInfo } from 'phosphor-vue';
import { Tooltip, Radio, RadioGroup } from 'ant-design-vue';

import CustumNumberInput from '@/components/shared/form/CustumNumberInput.vue';
import CustumCalender from '@/components/shared/form/CustumCalender.vue';

import ModalCard from './ModalCard.vue';

export default {
  components: {
    ModalCard,
    PhInfo,
    Tooltip,
    Radio,
    RadioGroup,

    CustumNumberInput,
    CustumCalender,
  },
  data() {
    return {
      spacesData: [
        { id: 1, name: 'per day' },
        { id: 2, name: 'per month' },
        { id: 3, name: 'per year' },
      ],
    };
  },
};
</script>
